import { useState } from "react";

import { makePostApiCall } from "../../shared/makeApiCall";
import { BannerNotificationType } from "../../components/SimpleBanner";
import ModelErrorComponent from "../../components/modals/ModelErrorComponent";

export function CreateLabSampleViewModel(logout) {
  const [labs, setLabs] = useState([
    { value: -1, label: "Select Laboratories" },
  ]);
  const [inProgress, setInProgress] = useState(false);
  const [showSimpleNotification, setShowSimpleNotification] = useState({
    show: false,
    message: null,
    title: null,
    type: BannerNotificationType.Success,
  });
  const [emptyModal, setEmptyModelOpen] = useState({
    open: false,
    childComponent: null,
  });

  const showErrorModal = (subtitle) => {
    setEmptyModelOpen({
      childComponent: (
        <ModelErrorComponent
          setOpen={setEmptyModelOpen}
          subtitle={subtitle}
          title="Error"
        />
      ),
      open: true,
    });
  };

  const getLabsForDropdown = async function () {
    let callResult = await makePostApiCall(`laboratoriesForDropdown`);
    if (callResult.success) {
      setLabs([
        { value: -1, label: "Select Laboratories" },
        ...callResult.data,
      ]);
    } else {
      if (callResult.errorStatus === 401) logout();
      else {
        // Show error modal for API failures
        const message =
          (callResult.data && callResult.data.message) ||
          callResult.errorMessage ||
          "Could not load laboratories";
        showErrorModal(message);
      }
    }
  };

  const createLabSample = async function (values, files) {
    setInProgress(true);
    try {
      let callResult;
      // Send JSON body when there are no files
      const jsonPayload = { ...values };
      callResult = await makePostApiCall("labSamples/create", jsonPayload);

      if (callResult.success) {
        return { success: true, data: callResult.data };
      }

      if (callResult.errorStatus === 401) {
        logout();
        return { success: false };
      }

      const errors =
        callResult.data && callResult.data.errors
          ? callResult.data.errors
          : null;
      const message = "Unable to create lab sample";

      // Show error modal for API failure
      showErrorModal(message);

      // Keep the simple notification for quick feedback as well
      setShowSimpleNotification({
        show: true,
        title: message,
        type: BannerNotificationType.Error,
      });

      if (errors) {
        // Return errors so the UI can map them to inputs
        return { success: false, message, errors };
      }

      return { success: false, message };
    } catch (err) {
      const message = "Unable to create lab sample";
      showErrorModal(message);
      setShowSimpleNotification({
        show: true,
        title: message,
        type: BannerNotificationType.Error,
      });
      return { success: false, message };
    }
  };

  return {
    labs,
    getLabsForDropdown,
    inProgress,
    createLabSample,
    setShowSimpleNotification,
    showSimpleNotification,
    emptyModal,
    setEmptyModelOpen,
  };
}

export default CreateLabSampleViewModel;
